import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import {
  selectHasMobileNavigation,
  selectIsHiddenLeversRTQ,
} from '../../../../../../CommonSelectors/CommonAreaSelector';
import { useClientId } from '../../../../../../_hooks/useClientId';
import { useRiskProfileCardQuery } from '../../../../../api/useRiskProfileCardQuery';
import { GoalCard } from '../GoalCard/GoalCard';
import { GoalCardError } from '../GoalCard/GoalCard.error';
import { GoalCardLoading } from '../GoalCard/GoalCard.loading';

export const RiskToleranceCard = () => {
  const { data, isLoading, error, refetch } = useRiskProfileCardQuery();

  const clientId = useClientId();

  const hasMobileNavigation = useSelector(selectHasMobileNavigation);
  const isHiddenLeversRTQ = useSelector(selectIsHiddenLeversRTQ);

  if (isLoading) {
    return <GoalCardLoading />;
  }

  if (error) {
    return <GoalCardError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  return (
    <GoalCard
      title={isHiddenLeversRTQ ? 'Risk Profile' : 'Risk Tolerance'}
      icon={<Icon className="far fa-tachometer" fontSize="h3" color="neutral.500" />}
      ctaText={data.riskScore === null ? 'Complete Workflow' : 'View your Result'}
      hideFooter={hasMobileNavigation}
      showCompletedLozenge
      isCompleted={data.riskScore !== null}
      onClick={() => {
        if (!hasMobileNavigation) {
          if (data.riskScore !== null) {
            ADV.util.Router.go2('RiskToleranceResults', {
              clientId,
              redirectTo: 'beFi',
            });
          } else {
            ADV.util.Router.go2('RiskToleranceWorkflow', {
              clientId,
              redirectTo: 'beFi',
            });
          }
        }
      }}
    >
      <>
        {data.riskScore === null ? (
          <Text>
            Understand how you think about risk and find the optimal level for you and your
            investment strategy.
          </Text>
        ) : (
          <Box
            mb="8"
            as="ul"
            css="list-style: none"
            p="0"
            display="flex"
            flexDirection="column"
            style={{ gap: 8 }}
            mt="4"
          >
            <Box as="li" display="flex" justifyContent="space-between">
              <Text fontSize="h6" textTransform="capitalize" fontWeight={600}>
                Risk Score
              </Text>
              <Text fontSize="h6" fontWeight={600}>
                {data.riskScore}
              </Text>
            </Box>
            <Box pt="4">
              {data.capacity !== null && (
                <Box as="li" display="flex" justifyContent="space-between">
                  <Text textTransform="capitalize">Capacity</Text>
                  <Text fontWeight={500}>{data.capacity.score}</Text>
                </Box>
              )}
              {data.tolerance !== null && (
                <Box as="li" display="flex" justifyContent="space-between">
                  <Text textTransform="capitalize">Tolerance</Text>
                  <Text fontWeight={500}>{data.tolerance.score}</Text>
                </Box>
              )}
              {data.composure !== null && (
                <Box as="li" display="flex" justifyContent="space-between">
                  <Text textTransform="capitalize">Composure</Text>
                  <Text fontWeight={500}>{data.composure.score}</Text>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </>
    </GoalCard>
  );
};
